import React, { Component } from 'react';
import { Row, Button, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = { trainings: [], loading: true };
    }
    render() {
        var title = "Logistic Workx";
        var imgUrl = "url('/img/Banners/logisticworkx.jpg')";

        const img = {
            backgroundImage: imgUrl,
            height: '55vh',
            width: 'auto',
            overflow: 'hidden',
            backgroundSize: 'cover',
            borderBottom: 'solid lightgray',
            backgroundColor: 'darkgray'
        }
        const img2 = {
            backgroundImage: imgUrl,
            height: '25vh',
            width: 'auto',
            overflow: 'hidden',
            backgroundSize: 'cover',
            borderBottom: 'solid lightgray',
            backgroundColor: 'darkgray'
        }

        const bolder = {
            fontWeight: '600'
        }

        return (
            <React.Fragment>
                <div style={img} className="text-center d-none d-lg-block">
                    <Row className="py-5 my-2">
                        <Col xs="6" className="pt-2">
                        </Col>
                        <Col xs="6" className="pt-2">
                            <h1 style={bolder} className="display-4 text-light">{title}<br></br>Trainer</h1>
                            <h6>
                                <Button tag={Link} to={"/training"} size="lg" color="primary" className="float-center mt-5"><b>Naar mijn trainingen</b></Button>
                            </h6>
                        </Col>
                    </Row>
                </div>

                <div className="d-block d-lg-none">
                    <div style={img2} className="text-center"></div>
                    <div className="text-center pt-5">
                        <h1 style={bolder} className="display-6 px-2">{title} Trainer</h1>
                        <h6>
                            <Button tag={Link} to={"/training"} size="lg" color="primary" className="float-center mt-3"><b>Naar mijn trainingen</b></Button>
                        </h6>
                    </div>
                </div>

                <Row className="pt-5 mt-4 mx-4">
                    <Col>
                        <div className="text-center">
                            <h6>
                                Wij helpen je met de theorie en bieden je een eenvoudige manier om het examen te maken.
                             </h6>
                            <h6 className="pb-5">
                                Ben je er klaar voor? Klik op de knop hieronder om naar je trainingen te gaan.
                            </h6>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

